import React from 'react'
import Hero from './Hero'
import TermsOFUse from '../profile/TermsOFUse'

const Terms = () => {
  return (
    <div>
        <Hero/>
        <div className=' main-prop padding-container'>
            <TermsOFUse/>
        </div>
        
    </div>
  )
}

export default Terms